import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

const TaskProgressBar = ({ progress }) => {
    if (!progress) return null;
    const total = progress.total || 0;
    const pct = progress.pct || 0;
    const indeterminate = total === 0;

    return (
        <Box sx={{ width: '100%' }}>
            {progress.step && (
                <Typography variant="caption" color="textSecondary" noWrap sx={{ display: 'block', mb: 0.25 }}>
                    {progress.step}
                </Typography>
            )}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <LinearProgress
                        variant={indeterminate ? 'indeterminate' : 'determinate'}
                        value={indeterminate ? undefined : pct}
                        sx={{ height: 6, borderRadius: 3 }}
                    />
                </Box>
                <Typography variant="caption" color="textSecondary" noWrap sx={{ minWidth: 40 }}>
                    {indeterminate ? '' : `${pct}%`}
                </Typography>
            </Box>
        </Box>
    );
};

export default TaskProgressBar;
